import { render, staticRenderFns } from "./AppRectangle.vue?vue&type=template&id=31f84d17&"
import script from "./AppRectangle.vue?vue&type=script&lang=js&"
export * from "./AppRectangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports